import proj4 from "proj4";
export class SinglePointCoordinate {
    constructor(lat, lng, crs) {
        this.lat = lat;
        this.lng = lng;
        this.crs = crs;
    }
    inCrs(v) {
        return this.crs === v;
    }
    project(toCrs) {
        if (this.inCrs(toCrs)) {
            return this.copy();
        }
        else {
            const [lng, lat] = proj4(this.crs, toCrs, [this.lng, this.lat]);
            return new SinglePointCoordinate(lat, lng, toCrs);
        }
    }
    toTransferable() {
        return {
            crs: this.crs,
            lng: this.lng,
            lat: this.lat,
        };
    }
    copy() {
        return new SinglePointCoordinate(this.lat, this.lng, this.crs);
    }
    static fromTransferable(singlePointCoordinate) {
        return new SinglePointCoordinate(singlePointCoordinate.lat, singlePointCoordinate.lng, singlePointCoordinate.crs);
    }
}
//# sourceMappingURL=SinglePointCoordinate.js.map